<style>
  .feather-icon{
    line-height: 24px;
    vertical-align: middle;
  }
</style>
<template>
  <div class="device-info" :class="[`${custom}`]">
    <div class="shadow-drop d-theme-dark-bg cursor-pointer round py-1 px-2 align-middle"  :class="[`bg-${status}`]" >
      <feather-icon icon="CheckIcon" svgClasses="h-5 w-5 text-white align-middle" v-if="status == 'primary'" />
      <feather-icon icon="AlertTriangleIcon" svgClasses="h-5 w-5 text-white" v-if="status == 'warning'" />
      <iconBase iconName="alarm" :width="18" :height="18" iconColor="#ffff" class="align-middle" v-else-if="status == 'danger'"><iconAlarm/></iconBase>
      <iconBase iconName="cancel" :width="18" :height="18" iconColor="#ffff" class="align-middle" v-else-if="status == 'grey'"><iconCancel/></iconBase>
      <feather-icon icon="CheckIcon" svgClasses="h-5 w-5 text-white stroke-current" v-else />
    </div>
    <span v-show="percent.length > 0" class="ml-5 font-bold align-middle" :class="[`text-${status} `]">{{percent}} <span v-if="percent != undefined">%</span></span>
    <span v-show="description.length > 0" class="ml-2 text-xs align-middle">{{description}}</span>
  </div>
</template>
<script>
import iconBase from '@/components/icons/iconBase'
import iconAlarm from '@/components/icons/iconAlarm'
import iconCancel from '@/components/icons/iconCancel'

export default {
  components: {
    iconBase,
    iconAlarm,
    iconCancel
  },
  props:{
    status: String,
    percent: {
      type: String,
      default: ''
    },
    custom: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    }
  }
}
</script>